

































import { FormBlock, SQLEditor } from '@/app/components';
import { computed, defineComponent, PropType, Ref } from '@vue/composition-api';
import { SAPHanaHarvesterConfiguration } from '../../../types';
import { AdditionalResponseData, SampleTable, IdentifierColumn } from '../common';

export default defineComponent({
    name: 'ReviewSAPHanaHarvester',
    model: {
        prop: 'configuration',
        event: 'change',
    },
    props: {
        configuration: {
            type: Object as PropType<SAPHanaHarvesterConfiguration>,
            required: true,
        },
        sample: {
            type: Array as PropType<Record<string, any>[]>,
            default: () => [],
        },
        sampleFields: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        structure: {
            type: Object as PropType<Record<string, string>>,
            default: () => {},
        },
        isFinalized: {
            type: Boolean,
            default: false,
        },
        sqlQueryPreview: {
            type: String,
            default: '',
        },
    },
    components: {
        AdditionalResponseData,
        FormBlock,
        SQLEditor,
        SampleTable,
        IdentifierColumn,
    },
    setup(props, { emit }) {
        const sapHanaConfiguration: Ref<SAPHanaHarvesterConfiguration> = computed({
            get: () => props.configuration,
            set: (newConfiguration: SAPHanaHarvesterConfiguration) => {
                emit('change', newConfiguration);
            },
        });

        return { sapHanaConfiguration };
    },
});
